<script setup lang="ts">
import ToolCornerMenuButton from "../toolbar/ToolCornerMenuButton.vue";
import { useSnapControls } from "@/composable/useSnapControls";
import { OBJECT_SNAP_MODE_UI_ORDER } from "@/drawing/snap";

const {
  isObjectSnapActive,
  toggleObjectSnap,
  isObjectSnapModeActive,
  toggleObjectSnapMode,
} = useSnapControls();
</script>

<template>
  <ToolCornerMenuButton
    phosphor-icon="chart-polar"
    :mode-on="isObjectSnapActive"
    :tooltip-title="$t('canvas:tools.snap.objectSnapTitle')"
    :tooltip-text="$t('canvas:tools.snap.objectSnap')"
    :menu-label="$t('canvas:tools.snap.objectSnapMenuTitle')"
    :menu-width="190"
    @toggle="toggleObjectSnap"
  >
    <!-- Choix multiple : le menu reste ouvert -->
    <div class="snap-popover-content" role="menu">
      <div class="snap-popover-label">
        {{ $t("canvas:tools.snap.selectModes") }}
      </div>
      <div class="snap-mode-list">
        <button
          v-for="mode in OBJECT_SNAP_MODE_UI_ORDER"
          :key="mode"
          type="button"
          role="menuitemcheckbox"
          class="snap-option"
          :class="{ active: isObjectSnapModeActive(mode) }"
          :aria-checked="isObjectSnapModeActive(mode)"
          @click="toggleObjectSnapMode(mode)"
        >
          <span class="snap-angle">{{ $t(`canvas:tools.snap.${mode}`) }}</span>
        </button>
      </div>
    </div>
  </ToolCornerMenuButton>
</template>
